// To easily generate these from server contract library enums, run a regex replace of `(\w+),` with `$1 = '$1',`

export enum BuildingCode {
  Unknown = 'Unknown',
  Bcnys2020 = 'Bcnys2020',
  Bcnys2025 = 'Bcnys2025',
  Boca = 'Boca',
  CanNbcc1995 = 'CanNbcc1995',
  CanNbcc2005 = 'CanNbcc2005',
  CanNbcc2010 = 'CanNbcc2010',
  CanNbcc2015 = 'CanNbcc2015',
  Cbc2019 = 'Cbc2019',
  Cbc2022 = 'Cbc2022',
  Cbc2025 = 'Cbc2025',
  Crc2022 = 'Crc2022',
  Crc2025 = 'Crc2025',
  Fbc2001 = 'Fbc2001',
  Fbc2004 = 'Fbc2004',
  Fbc2007 = 'Fbc2007',
  Fbc2010 = 'Fbc2010',
  Fbc2013 = 'Fbc2013',
  Fbc2017 = 'Fbc2017',
  Fbc2020 = 'Fbc2020',
  Fbc2023 = 'Fbc2023',
  Fbc2026 = 'Fbc2026',
  Frc2004 = 'Frc2004',
  Frc2007 = 'Frc2007',
  Frc2010 = 'Frc2010',
  Frc2013 = 'Frc2013',
  Frc2017 = 'Frc2017',
  Frc2020 = 'Frc2020',
  Frc2023 = 'Frc2023',
  Frc2026 = 'Frc2026',
  Fresno = 'Fresno',
  Hud = 'Hud',
  Hud175nd = 'Hud175nd',
  Hud200nd = 'Hud200nd',
  Hud25dest = 'Hud25dest',
  Ibc2000 = 'Ibc2000',
  Ibc2003 = 'Ibc2003',
  Ibc2006 = 'Ibc2006',
  Ibc2009 = 'Ibc2009',
  Ibc2012 = 'Ibc2012',
  Ibc2015 = 'Ibc2015',
  Ibc2018 = 'Ibc2018',
  Ibc2021 = 'Ibc2021',
  Ibc2024 = 'Ibc2024',
  Irc2000 = 'Irc2000',
  Irc2003 = 'Irc2003',
  Irc2006 = 'Irc2006',
  Irc2009 = 'Irc2009',
  Irc2012 = 'Irc2012',
  Irc2015 = 'Irc2015',
  Irc2018 = 'Irc2018',
  Irc2021 = 'Irc2021',
  Irc2024 = 'Irc2024',
  Mnsrc = 'Mnsrc',
  MnsrcIrc2012 = 'MnsrcIrc2012',
  NbcBoca = 'NbcBoca',
  Ncbc2018 = 'Ncbc2018',
  Ohiobc03 = 'Ohiobc03',
  Ohiobc07 = 'Ohiobc07',
  Ohiobc11 = 'Ohiobc11',
  Ohiobc13 = 'Ohiobc13',
  Ohiorc03 = 'Ohiorc03',
  Ohiorc07 = 'Ohiorc07',
  Ohiorc11 = 'Ohiorc11',
  Ohiorc13 = 'Ohiorc13',
  Rcnys2025 = 'Rcnys2025',
  Sbc = 'Sbc',
  Scbc2018 = 'Scbc2018',
  Sfbc = 'Sfbc',
  Ubc = 'Ubc',
  Ubc97 = 'Ubc97',
  Wisc = 'Wisc',
  WiscIbc = 'WiscIbc',
  WiscIbc2006 = 'WiscIbc2006',
  WiscIbc2009 = 'WiscIbc2009',
  WiscIbc2015 = 'WiscIbc2015',
  WiscIrc = 'WiscIrc',
  WiscIrc2006 = 'WiscIrc2006',
}

export enum DesignStandard {
  Unknown = 'Unknown',
  Ansi95 = 'Ansi95',
  Tpi2002 = 'Tpi2002',
  Tpi2007 = 'Tpi2007',
  Tpi2014 = 'Tpi2014',
  Tpi2022 = 'Tpi2022',
}

type Tpi1Year = 1995 | 2002 | 2007 | 2014 | 2022;

export function getTpi1Year(designStandard: DesignStandard): Tpi1Year | null {
  switch (designStandard) {
    case DesignStandard.Unknown:
      return null;
    case DesignStandard.Ansi95:
      return 1995;
    case DesignStandard.Tpi2002:
      return 2002;
    case DesignStandard.Tpi2007:
      return 2007;
    case DesignStandard.Tpi2014:
      return 2014;
    case DesignStandard.Tpi2022:
      return 2022;
  }
}

/** Determines whether {@link designStandard} represents TPI 1 edition {@link referenceVersion} or later. */
export function isTpi1VersionOrLater(designStandard: DesignStandard, referenceVersion: Tpi1Year) {
  const year = getTpi1Year(designStandard);
  return year != null && year >= referenceVersion;
}

const sectionSymbol = '\u00A7';
const nonBreakingSpace = '\u00A0';

export function tpiSection(section: string, designStandard?: DesignStandard): string {
  const tpi1Year = designStandard == null ? null : getTpi1Year(designStandard);
  return `TPI${nonBreakingSpace}1${tpi1Year == null ? '' : `-${tpi1Year}`} ${sectionSymbol}${nonBreakingSpace}${section}`;
}

export enum DeflectionLoading {
  Live = 'Live',
  Total = 'Total',
  LiveAndCreep = 'LiveAndCreep',
}

export function formatDeflectionLoading(loading: DeflectionLoading): string {
  return loading === DeflectionLoading.LiveAndCreep ? 'Live + Creep' : loading.toString();
}
